import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wfdss-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
